The primary method of payment and the interval in which it is paid for a position.
